/*
* Copyright (C) Regione Lombardia
*/
import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CoreI18nConfigs } from '@core/configs/i18n.config';
import {
    DatalistAnagrafica,
    DocumentoManutenzione,
    Manutenzione
} from '@models';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ManutenzioneService } from '@shared/services/manutenzione.service';
import { OperaService } from '@shared/services/opera.service';
import { UtilsService } from '@shared/services/utils.service';
import { ToolkitGestioneOperaModalUploadDocumentoComponent } from '../modal-upload-documento/modal-upload-documento.component';

@Component({
    selector: 'app-toolkit-opera-modal-manutenzione',
    templateUrl: './modal-manutenzione.component.html',
})
export class ToolkitGestioneOperaModalManutenzioneComponent implements OnInit {
    
    @Input() canEdit: boolean;
    @Input() azione: string;
    @Input() params: Manutenzione;
    @Input() items: DocumentoManutenzione[];
    @Input() datalist: DatalistAnagrafica;

    public criteriaForm: FormGroup;

    constructor(
        public activeModal: NgbActiveModal,
        private operaService: OperaService,
        private utilsService: UtilsService,
        private fb: FormBuilder,
        private modalService: NgbModal,
        private manutenzioneService: ManutenzioneService
    ) { }

    ngOnInit() {
        this.criteriaForm = this.fb.group({
            idInterventoManutenzione: this.fb.control(null),
            idOpera: this.fb.control(this.operaService.operaSession.idOpera, Validators.required),
            idTipoIntervento: this.fb.control(null),
            dataPrevista: this.fb.control(null),
            descrizione: this.fb.control(null),
            enteManutentore: this.fb.control(null),
            dataEsecuzione: this.fb.control(null),
            vitaUtile: this.fb.control(null),
            dataProssimaManutenzione: this.fb.control(null),
            linkPianoManutenzione: this.fb.control(null),
            note: this.fb.control(null)
        });
        if (this.params) {
            this.criteriaForm.patchValue(this.params);
        }
        if (!this.canEdit) {
            this.criteriaForm.disable();
        }
    }

    public saveManutenzione() {
        if (this.criteriaForm.invalid) {
            this.utilsService.showError(CoreI18nConfigs.messages.fieldRequired);
            return;
        }
        this.activeModal.close(this.criteriaForm);
    }

    public documentoManutenzioneDownload(item: DocumentoManutenzione) {
        this.manutenzioneService.downloadDocumento(item).subscribe();
    }

    public addItem() {
        const modal = this.modalService.open(ToolkitGestioneOperaModalUploadDocumentoComponent, {size: 'xl'});
        modal.componentInstance.azione = 'Aggiungi';
        modal.componentInstance.datalist = this.datalist;
        modal.result.then(result => {
            if (result.file) {
                this.manutenzioneService.insertDocumento(result.file, this.criteriaForm.get('idInterventoManutenzione')?.value, result.form.getRawValue()).subscribe(responseInsert => {
                    this.utilsService.showSuccess(CoreI18nConfigs.messages.genericSuccess);
                    this.manutenzioneService.documentoManutenzioneByIdManutenzione(this.criteriaForm.get('idInterventoManutenzione')?.value).subscribe(response => {
                        this.items = response;
                    });
                });
            }
        }).catch(e => {});
    }

    public editItem(documento: DocumentoManutenzione) {
        const modal = this.modalService.open(ToolkitGestioneOperaModalUploadDocumentoComponent, {size: 'xl'});
        modal.componentInstance.azione = 'Modifica';
        modal.componentInstance.datalist = this.datalist;
        modal.componentInstance.params = documento;
        modal.componentInstance.canEdit = true;
        modal.result.then(result => {
            if (result) {
                this.manutenzioneService.updateDocumentoManutenzione(result.form.getRawValue()).subscribe(responseUpdate => {
                    this.utilsService.showSuccess(CoreI18nConfigs.messages.genericSuccess);
                    this.manutenzioneService.documentoManutenzioneByIdManutenzione(this.criteriaForm.get('idInterventoManutenzione')?.value).subscribe(response => {
                        this.items = response;
                    });                
                });
            }
        }).catch(e => {});
    }

    public deleteItem(idDocumento: number) {
        this.manutenzioneService.deleteDocumento(idDocumento).subscribe(responseDelete => {
            this.manutenzioneService.documentoManutenzioneByIdManutenzione(this.criteriaForm.get('idInterventoManutenzione')?.value).subscribe(response => {
                this.items = response;
            });
        });
    }

}
